import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"


export const requestTicketsStatsOverview = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-stats-overview", verbose: verbose })
}


export const requestTicketsChronologicalCount = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-chronological", verbose: verbose })
}

export const requestTicketsChronologicalCount2 = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-chronological2", verbose: verbose })
}

export const requestUserStatsOverview = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/get-user-stats-overview", verbose: verbose })
}


export const requestTicketsFirstReplyTimeChronological = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-first-reply-time-chronological", verbose: verbose })
}

export const requestGetDailyUserStats = ({ startDate, endDate, userId, action, page, pageSize, verbose = false }) => {
    const formData = new FormData()
    formData.append("start_date", startDate)
    endDate && formData.append("end_date", endDate)
    formData.append("userid", userId)
    action && formData.append("action", action)
    page && formData.append("page", page)
    pageSize && formData.append("page_size", pageSize)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/get-daily-user-stats", body: formData, verbose: verbose })
}

export const requestUserDailySummary = ({ startDate, endDate, userId, page, pageSize, view, verbose = false }) => {
    const formData = new FormData()
    formData.append("start_date", startDate)
    endDate && formData.append("end_date", endDate)
    formData.append("userid", userId)
    page && formData.append("page", page)
    pageSize && formData.append("page_size", pageSize)
    view && formData.append("view", view)
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/get-user-daily-summary", body: formData, verbose: verbose })
}